import $ from 'jquery';
import layout from '~/js/services/layout';
import scroller from '~/js/services/scroller';


// Container element (internal.$e) is the source of truth for the positioning
// and sizing of the sizer element (elements.sizer). It should be `position:
// static` with the following CSS applied:
//
// internal.originalSize = width of internal.$e
// internal.targetSize = `min-width`
// internal.minScroll (scroll position when sizing begins) = `top`
// internal.maxScroll (scroll position when sizing ends) = `bottom`


const scrollSizer = function (options) {
    let o, m, internal, elements, fn, handlers;


    o = $.extend({
        $e: null,
        selector: ''
    }, options);


    m = scrollSizer.markup;


    internal = {
        $e: o.$e || $(o.selector),
        originalSize: 0,
        targetSize: 0,
        minScroll: 0,
        maxScroll: 0,
        differential: 0
    };


    elements = {
        sizer: internal.$e.find(`.${m.SIZER}`)
    };


    fn = {
        init () {
            fn.updateDifferentials();
            fn.updateSize(scroller.getScrollTop());

            internal.$e.addClass(m.SETUP);

            scroller.onScroll(handlers.scrolled);
            layout.onResize(handlers.resized);
        },

        updateDifferentials () {
            internal.targetSize = parseInt(internal.$e.css('min-width'), 10) || 0;
            if (!internal.targetSize) {
                return;
            }

            internal.minScroll = parseInt(internal.$e.css('top'), 10) || 0;
            internal.maxScroll = parseInt(internal.$e.css('bottom'), 10) || 0;
            internal.originalSize = internal.$e.width();
            internal.differential = (internal.originalSize - internal.targetSize) / internal.maxScroll;
        },

        updateSize (scrollTop) {
            if (!internal.targetSize) {
                elements.sizer.css('width', '');
                return;
            }

            if (scrollTop > internal.minScroll) {
                const top = Math.min(scrollTop - internal.minScroll, internal.maxScroll);
                const change = top * internal.differential;
                const newSize = Math.floor(internal.originalSize - change);

                elements.sizer.css('width', newSize);
            } else {
                elements.sizer.css('width', internal.originalSize);
            }
        },

        destroy () {
            scroller.offScroll(handlers.scrolled);
            layout.offResize(handlers.resized);
        }
    };


    handlers = {
        scrolled (d) {
            fn.updateSize(d.scrollTop);
        },

        resized () {
            fn.updateDifferentials();
            fn.updateSize(scroller.getScrollTop());
        }
    };


    fn.init();
};


scrollSizer.markup = {
    // dom selector
    CONTAINER: 'scroll-sizer',
    SIZER: 'scroll-sizer__element',

    // states
    SETUP: 'state-setup'
};


export default scrollSizer;



// WEBPACK FOOTER //
// ./assets/js/components/scroll-sizer.js